const divFormActions = {
  fileError: 'Espere a que se carguen todos los archivos'
};

export default divFormActions;
